<template>
  <vs-popup
    ref="popup"
    class="small"
    title="Помощь"
    :active="isShow"
    :class="{ 'vs-popup--no-header': responseForm }"
    @close="onClose"
  >
    <form v-if="!responseForm" class="flex flex-col" @submit.prevent="sendData">
      <p class="my-1">
        Если у вас появились вопросы
      </p>
      <p class="font-semibold text-lg leading-28 mb-6">
        Позвоните менеджеру
      </p>
      <div class="flex p-4 bg-white-darkest rounded-8 items-center">
        <img
          width="64"
          height="64"
          class="w-64px h-64px mr-4"
          src="@/assets/images/logo/kolesa-avatar.png"
        >
        <div class="flex flex-col">
          <p>{{ manager.name }}</p>
          <p class="font-semibold text-lg leading-28">
            {{ manager.phone | phone }}
          </p>
        </div>
      </div>
      <div class="mt-4">
        <p class="font-semibold text-lg leading-28 mb-4">
          Или оставьте заявку здесь
        </p>
        <p class="text-grey text-sm mb-2">
          Выберите категорию:
        </p>
        <multiselect
          ref="select"
          v-model="selectedCategory"
          class="mb-4 text-base"
          :options="categoryData"
          track-by="value"
          label="label"
          :searchable="false"
          :allow-empty="false"
          :max-height="180"
          @close="resetSelectFocusPosition('select')"
        >
          <template v-slot:caret>
            <i-arrow-bottom class="multiselect__icon" />
          </template>
        </multiselect>
        <p class="text-grey text-sm mb-2">
          Комментарий
        </p>
        <vs-textarea v-model="commentToSend" required maxlength="300" placeholder="Напишите комментарий" />
        <vs-button button="submit" class="w-144px">
          Отправить
        </vs-button>
      </div>
    </form>
    <div
      v-else
      class="flex items-center justify-center flex-col"
      :class="{'text-success': responseForm === 'success', 'text-danger': responseForm === 'failed' }"
    >
      <i-ok-filled v-if="responseForm === 'success'" />
      <i-error-filled v-else />
      <p class="mt-2 text-semibold text-xl leading-32 text-center">
        {{ responseForm === 'success'
          ? 'Заявка отправлена'
          : 'Что-то пошло не так, попробуйте еще раз позже' }}
      </p>
    </div>
  </vs-popup>
</template>

<script>
import { mapGetters } from 'vuex';
import Multiselect from 'vue-multiselect';
import IErrorFilled from '@/assets/svg/icons/small-error-filled.svg';
import IOkFilled from '@/assets/svg/icons/small-ok-filled.svg';
import IArrowBottom from '@/assets/svg/icons/arrow-small-bottom.svg';

export default {
  name:       'HelpPopup',
  components: {
    Multiselect,
    IErrorFilled,
    IOkFilled,
    IArrowBottom,
  },
  props: {
    isShow: {
      type:    Boolean,
      default: false,
    },
    refillComplex: {
      type:    String,
      default: '',
    },
  },
  data() {
    return {
      closeTimeout:     null,
      responseForm:     '',
      commentToSend:    '',
      selectedCategory: {
        label: 'Заявка на пополнение лидов',
        value: 1,
      },
      categoryData: [
        {
          label: 'Заявка на пополнение лидов',
          value: 1,
        },
        {
          label: 'Технические проблемы',
          value: 2,
        },
        {
          label: 'Проблемы с контентом',
          value: 3,
        },
        {
          label: 'Нужна помощь по сайту',
          value: 4,
        },
        {
          label: 'Предложения по улучшению',
          value: 5,
        },
        {
          label: 'Другой вопрос',
          value: 6,
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
      manager:  'help/getManager',
    }),
  },
  watch: {
    refillComplex(val) {
      this.commentToSend = val ? `Автосалон ${val}` : '';
      this.selectedCategory = {
        label: 'Заявка на пополнение лидов',
        value: 1,
      };
    },
  },
  created() {
    this.$store.dispatch('help/fetchManager');
  },
  methods: {
    /**
     * При закрытые контекстное меню сбрасывает фокус элемента, ставить в изначальное 1-ую позицию
     *
     * @param {String} ref - Пишем на какой ref записан компонент, чтобы получить доступ к экземпляру и его методам
     */
    resetSelectFocusPosition(ref) {
      this.$refs[ref].pointerSet(0);
    },

    /**
     * Событие при закрытые модалки
     */
    onClose() {
      this.$emit('toggle', false);

      setTimeout(() => {
        this.responseForm = '';
        this.commentToSend = '';

        if (this.closeTimeout) {
          clearTimeout(this.closeTimeout);
          this.closeTimeout = null;
        }
      }, 500);
    },

    /**
     * Отправка сообщение на backend
     */
    sendData() {
      this.$store.dispatch('help/sendMessage', {
        type:    this.selectedCategory.value,
        message: this.commentToSend,
      }).then(() => {
        this.responseForm = 'success';
      }).catch(() => {
        this.responseForm = 'failed';
      }).finally(() => {
        this.closeTimeout = setTimeout(() => {
          this.$refs.popup.$listeners.close();
        }, 3000);
      });
    },
  },
};
</script>
